import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { authService } from '../../services/authService';
import Button from '../../components/ui/Button';

const VerifyEmailPage: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const [status, setStatus] = useState<'pending' | 'success' | 'error'>('pending');
  const [message, setMessage] = useState<string>('Verifying your email...');

  useEffect(() => {
    const verify = async () => {
      if (!token) {
        setStatus('error');
        setMessage('Verification token missing.');
        return;
      }
      try {
        const res = await authService.verifyEmail(token);
        setStatus('success');
        setMessage(res.message || 'Email verified successfully.');
      } catch (e: any) {
        setStatus('error');
        setMessage(e?.response?.data?.error || 'Invalid or expired verification link.');
      }
    };
    verify();
  }, [token]);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="flex justify-center">
          <div className="w-12 h-12 rounded-full patreon-primary-gradient" style={{ background: 'var(--patreon-btn-primary-bg)' }}></div>
        </div>
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
          Verify your email
        </h2>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow-lg sm:rounded-lg sm:px-10 text-center">
          {status === 'pending' && (
            <p className="text-gray-700">{message}</p>
          )}
          {status === 'success' && (
            <>
              <p className="text-green-700 mb-6">{message}</p>
              <Link to="/login">
                <Button>Continue to login</Button>
              </Link>
            </>
          )}
          {status === 'error' && (
            <>
              <p className="text-red-700 mb-6">{message}</p>
              <Link to="/login">
                <Button variant="outline">Back to login</Button>
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyEmailPage;

